const mandatoryStatisticsActions = {
  ADD_TO_CART: 'ADD_TO_CART',
  ADD_TO_WISHLIST: 'ADD_TO_WISHLIST',
  INIT_PLANNING_SESSION: 'INIT_PLANNING_SESSION',
  SEND_DESIGN_INTERACTION_EVENT: 'SEND_DESIGN_INTERACTION_EVENT',
};

export default mandatoryStatisticsActions;
